export default [
    "24 24",
    '<path d="M4 11.03V4.54983C4 4.24617 4.24617 4 4.54983 4H11.9097C12.0555 4 12.1954 4.05793 12.2985 4.16104L20.0511 11.9136C20.2658 12.1283 20.2658 12.4765 20.0511 12.6912L13.1311 19.6112C12.9163 19.8259 12.5682 19.8259 12.3535 19.6112L4.16104 11.4188C4.05793 11.3157 4 11.1758 4 11.03Z" stroke="var(--ci-primary-color, currentColor)" fill="none" class="stroke-over"  stroke-width="2"/>\n' +
    '<circle cx="8.34332" cy="8.01373" r="1.37457" fill="var(--ci-primary-color, currentColor)" />']

